import React from 'react';
import { Message } from '@/widget/domain/message';
import useMessageInput from '@/widget/ui/hooks/useMessageInput';
import sendIcon from '@/widget/ui/images/send-icon.svg';
import attachmentButton from '@/widget/ui/images/clip.png';
import cx from 'classnames';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { ReactSVG } from 'react-svg';
import styles from './MessageInput.module.scss';

interface Props {
  addMessage: (conversationKey: string, message: Message) => void;
  handleResize: (previousHeight: number, currentHeight: number) => void;
  active: boolean;
}

function MessageInput({ addMessage, handleResize, active }: Props) {
  const { settings } = useChatWidgetContext();
  const { host, color, textColor } = settings;
  const {
    text,
    attachments,
    sending,

    sendMessage,
    setText,
    triggerUpload,
    handleUploaded,
    handleFilePaste,

    textarea,
    textareaContainer,
    fileInput,
  } = useMessageInput(active, addMessage, handleResize);

  const handleInput = (e) => {
    setText(e.target.value);
  };

  const handleEnterClick = (e) => {
    if (!e.shiftKey && e.keyCode === 13) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div ref={textareaContainer} className={styles.container}>
      <textarea
        value={text}
        placeholder={window.ChatWidget.i18n.t('chat_widget.message_input.placeholder')}
        ref={textarea}
        rows={1}
        onInput={handleInput}
        onKeyDown={handleEnterClick}
        onPaste={handleFilePaste}
        disabled={!active || sending}
      />
      <div
        style={{ backgroundImage: `url("${host}${attachmentButton}")` }}
        className={cx(styles.attachmentButton, { [styles.inactive]: attachments.length >= 10 })}
        onClick={triggerUpload}
      >
        <div
          style={{ backgroundColor: color }}
          className={cx(styles.counter, { [styles.active]: attachments.length > 0 })}
        >
          {attachments.length}
        </div>
      </div>
      <button
        disabled={!active || (!text.trim().length && !attachments.length) || sending}
        onClick={sendMessage}
        type="submit"
        className={styles.sendButton}
        style={{ backgroundColor: color, color: textColor }}
      >
        <ReactSVG src={host + sendIcon} />
      </button>
      <input
        className={styles.fileInput}
        ref={fileInput}
        type="file"
        hidden
        onChange={handleUploaded}
      />
    </div>
  );
}

export default MessageInput;
